import type { Router, RouterSlice } from './app-state';

export const getRouter = (state: RouterSlice): Router => state.router;
